import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import UpdateEmployeeForm from "../../components/forms/UpdateEmployeeForm";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const UpdateEmployeePage = (props) => (
  <Page enableGoBack title="Medewerker wijzigen">
    <CenteredPageContentContainer>
      <PaperContainer title="Medewerker wijzigen">
        <UpdateEmployeeForm employeeEmail={props.match.params.employee_email} />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

UpdateEmployeePage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      employee_email: PropTypes.string.isRequired,
    }),
  }),
};

export default UpdateEmployeePage;



// WEBPACK FOOTER //
// ./src/pages/Employee/UpdateEmployeePage.js